import { render, staticRenderFns } from "./mobileFileCopy.vue?vue&type=template&id=2fabd868&scoped=true&"
import script from "./mobileFileCopy.vue?vue&type=script&lang=js&"
export * from "./mobileFileCopy.vue?vue&type=script&lang=js&"
import style0 from "./mobileFileCopy.vue?vue&type=style&index=0&id=2fabd868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fabd868",
  null
  
)

export default component.exports